module.exports = __webpack_public_path__ + "static/media/27.61e1e7c0.png";